import React, { useEffect } from 'react';
// import './Home.css';
import Navbar from '../H&F/Navbar';
import Footer from '../H&F/Footer';
import './ac-service.css';
import ACSERVICEHERO from '../images/ACSERVICEHERO.webp';
import Discliamber from './Discliamer'
import ACSERVICE1 from '../images/ACSERVICEGAL.webp';
import ACMAN1 from '../images/ACMAN1.webp';
import ACMAN2 from '../images/ACMAN2.webp';
import ACMAN3 from '../images/ACMAN3.webp';
import ACMAN4 from '../images/ACMAN4.webp';
import ACMAN5 from '../images/ACMAN5.webp';
import ACMAN6 from '../images/ACMAN6.webp';


export default function HOME() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

const handleSubmit = async (e) => {
  e.preventDefault();
  const form = e.target;

   const formData = {
    name: form.name.value,
    phone: form.phone.value,
    location: form.location.value,
    issue: `  ${form.issue.value}
    
    - this calls coming from madurai 2.0 Nagaraj Account (HomeApplianceServiceMadurai.in)
    `,  
    toMail: "expresshelplinecare@gmail.com",
  };

  const spinner = document.getElementById("spinnerOverlay");
  if (spinner) spinner.style.display = "flex";

  try {
    const res = await fetch(
      "https://form.e2ecrm.in/api/sendmail",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      }
    );

    if (!res.ok) {
      throw new Error(`Server responded with ${res.status}`);
    }

    let data;
    try {
      data = await res.json();
    } catch {
      throw new Error("Invalid JSON response from server");
    }
 alert("Thank you! Your service request is confirmed. Our engineer will call you shortly.");
    form.reset();
  } catch (err) {
    console.error("Form submit error:", err);
    alert(`Error sending complaint: ${err.message}`);
  } finally {
    if (spinner) spinner.style.display = "none";
  }
};
 


  return (
    <>
      <div><Navbar /></div>

     
        <section id="hero" style={{ backgroundImage: `url(${ACSERVICEHERO})`}}>
          <div className="hero-content">
            <h1>Expert AC Repair & Maintenance</h1>
<p>Fast, reliable, and affordable solutions for all types of air conditioners. </p>

            <a href="tel:+918610867933" className="hero-btn">+91 86108 67933</a>
          </div>
          

      {/* Right Form */}
      <div className="form-container">
        <form id="bookingForm" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Enter your full name"
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Enter your mobile number"
            required
          />
          <input
            type="text"
            name="location"
            placeholder="Enter your complete address"
            required
          />
          <textarea
            name="issue"
            placeholder="Describe your appliance problem"
            required
          ></textarea>
             <p
  style={{
    marginTop: "12px",
    fontSize: "14px",
    color: "#ffffff",
    fontWeight: "700",
    textAlign: "center",
  }}
>
  Your information is kept secure and used only for your service request.
</p>
          <button type="submit">Book Complaint</button>
        </form>
      </div>
     

    {/* Dot Loading */}
    <div id="spinnerOverlay" className="spinner-overlay">
      <div className="dot-loader">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p className="loading-text">Booking your complaint</p>
    </div>
 
        </section>



{/* 
        <section class="contact-icons">
  <div class="contact-item phone">
    <a href="tel:+918610867933" class="icon-link">
      <span class="icon phone-icon"></span>
      <h5>Call Now</h5>
    </a>
  </div>
  <div class="contact-item whatsapp">
    <a href="https://wa.me/8610867933" class="icon-link">
      <span class="icon whatsapp-icon fab fa-whatsapp"></span>
      <h5>WhatsApp Now</h5> 
    </a>
  </div>
  <div class="contact-item mail">
    <a href="#" class="icon-link">
      <span class="icon mail-icon"></span>
      <h5>Email Now</h5>
    </a>
  </div>
</section>


 */}








        {/* <section id="about">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <h2>About Us</h2>
        <p class="about-description">
          We are a trusted home appliance service company with over 6 years of experience providing exceptional service and 100% customer satisfaction. Our experts are skilled in servicing a wide range of home appliances, ensuring that your household operates smoothly.
        </p>

        <div class="services">
          <div class="service-item">
            <img src={WASHIGIMAGE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
            <h3 class="service-title">Washing Machine Service</h3>
          </div>
          <div class="service-item">
          <img src={ACSERVICE1} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
            <h3 class="service-title" id="UPDOWN">AC Service</h3>
          </div>
          <div class="service-item">
          <img src={FRIDGESERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
            <h3 class="service-title" id="UPDOWN">TV Service</h3>
          </div>
          <div class="service-item">
          <img src={MICROSERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
            <h3 class="service-title">Microwave Oven Service</h3>
          </div>
          <div class="service-item">
          <img src={TVSERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
            <h3 class="service-title">Fridge Service</h3>
          </div>
          <div class="service-item">
          <img src={WATERHEATERSERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
            <h3 class="service-title">Water Heater Service</h3>
          </div>
          <div class="service-item">
          <img src={WATERPURIFIERSERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
            <h3 class="service-title">Water Purifier Service</h3>
          </div>
        </div>

        <p class="about-footer">
          With over 6+ years of experience and a 100% customer satisfaction guarantee, we ensure your appliances are in good hands.
        </p>
      </div>
    </div>
  </div>
</section>

 */}







<section id="how-we-work">
  <h2>How We Work</h2>
  <div class="work-cards">
    <div class="work-card">
      <i class="fas fa-bullhorn"></i>
      <h3>Promotion</h3>
      <p>We promote our website using Google Ads to get daily regular customers.</p>
    </div>
    <div class="work-card">
      <i class="fas fa-phone-alt"></i>
      <h3>Contact Us</h3>
      <p>Customers can reach us directly via the phone call option available on our website.</p>
    </div>
    <div class="work-card">
      <i class="fas fa-clipboard-list"></i>
      <h3>Complaint Registration</h3>
      <p>Our customer team registers the issue and forwards it to our technician.</p>
    </div>
    <div class="work-card">
      <i class="fas fa-calendar-check"></i>
      <h3>Technician Visit</h3>
      <p>Our technician gets an appointment and visits the customer's place to resolve the issue within 3-4 hours.</p>
    </div>
    <div class="work-card">
      <i class="fas fa-money-check-alt"></i>
      <h3>Service Charge</h3>
      <p>The basic service charge is ₹300 across Tamil Nadu. Spare parts charges are separate.</p>
    </div>
  </div>
</section>


<section id="gallery">
  <h2>Our Gallery</h2>
  <div class="gallery-grid">
    <div class="gallery-item large-item">
      <img src={ACMAN1} alt="Image 1"/>
    </div>
    <div class="gallery-item medium-item" >
      <img src={ACMAN2} alt="Image 2"/>
    </div>
    <div class="gallery-item medium-item" >
      <img src={ACMAN3} alt="Image 3"/>
    </div>
    <div class="gallery-item large-item">
      <img src={ACMAN4} alt="Image 4"/>
    </div>
    <div class="gallery-item medium-item" >
      <img src={ACMAN5} alt="Image 5"/>
    </div>
    <div class="gallery-item medium-item" >
      <img src={ACMAN6} alt="Image 6"/>
    </div>
  
  </div>
</section>


<section id="tech-special">
  <h2>Our Key Benefits</h2>
  <div class="benefit-cards">
    <div class="benefit-card">
      <i class="fas fa-cogs"></i>
      <h3>Tech Specialist</h3>
      <p>Our team consists of highly skilled technicians who specialize in all home appliance repairs.</p>
    </div>
    <div class="benefit-card">
      <i class="fas fa-wrench"></i>
      <h3>Quick Fixer</h3>
      <p>We diagnose and fix issues quickly, minimizing any inconvenience to our customers.</p>
    </div>
    <div class="benefit-card">
      <i class="fas fa-truck-fast"></i>
      <h3>Fast Delivery</h3>
      <p>We offer quick response times and arrive promptly at your location to deliver our services.</p>
    </div>
    <div class="benefit-card">
      <i class="fas fa-users"></i>
      <h3>Customer Friendly</h3>
      <p>Our customer support team is available to assist you every step of the way with a friendly approach.</p>
    </div>
    <div class="benefit-card">
      <i class="fas fa-check-circle"></i>
      <h3>High Quality Work</h3>
      <p>We ensure that every service we offer meets the highest quality standards and customer satisfaction.</p>
    </div>
  </div>
</section>










<section id="our-services">
  <h2>Our Services</h2>
  <div class="container">
   
   
    <div class="row service-item-washing-machine">
      <div class="col-md-6">
        <img src={ACMAN1} alt="Washing Machine Service" title="Washing Machine Service" class="img-fluid" />
      </div>
      <div class="col-md-6">
        <h3 id="service-heading-washing-machine">Ac Unit Checkup</h3>
        <p id="service-description-washing-machine">Choose our AC indoor unit checkup service and enjoy a comprehensive and professional inspection that ensures optimal performance and extended lifespan for your air conditioner.</p>
      </div>
    </div>

  
    <div class="row service-item-ac-service">
      <div class="col-md-6">
        <img src={ACMAN2} alt="AC Service" title="AC Service" class="img-fluid" />
      </div>
      <div class="col-md-6">
        <h3 id="service-heading-ac-service">AC Installation</h3>
        <p id="service-description-ac-service">Our AC installation service ensures your air conditioning unit is set up correctly, providing optimal cooling, enhanced comfort, and energy efficiency for your home.</p>
      </div>
    </div>

 
    <div class="row service-item-fridge-service">
      <div class="col-md-6">
        <img src={ACMAN3} alt="Fridge Service" title="Fridge Service" class="img-fluid" />
      </div>
      <div class="col-md-6">
        <h3 id="service-heading-fridge-service">Ac Dust Clean</h3>
        <p id="service-description-fridge-service">We offer comprehensive AC dust cleaning services that enhance your air conditioner's cooling efficiency and improve air quality while extending its lifespan.</p>
      </div>
    </div>

   
    <div class="row service-item-tv-service">
      <div class="col-md-6">
        <img src={ACMAN4} alt="TV Service" title="TV Service" class="img-fluid" />
      </div>
      <div class="col-md-6">
        <h3 id="service-heading-tv-service">Gas Checkup</h3>
        <p id="service-description-tv-service">Our AC gas checkup service ensures your air conditioner operates efficiently, with expert inspection and maintenance to maintain optimal cooling performance.</p>
      </div>
    </div>

    
    <div class="row service-item-microwave-oven-service">
      <div class="col-md-6">
        <img src={ACMAN5} alt="Microwave Oven Service" title="Microwave Oven Service" class="img-fluid" />
      </div>
      <div class="col-md-6">
        <h3 id="service-heading-microwave-oven-service">Indoore Filter</h3>
        <p id="service-description-microwave-oven-service">Get reliable indoor filter and grill cleaning services that ensure efficient air circulation and improved cooling performance. We handle all types of maintenance with precision.</p>
      </div>
    </div>

    
    <div class="row service-item-water-heater-service">
      <div class="col-md-6">
        <img src={ACMAN6} alt="Water Heater Service" title="Water Heater Service" class="img-fluid" />
      </div>
      <div class="col-md-6">
        <h3 id="service-heading-water-heater-service">Out Door Checkup</h3>
        <p id="service-description-water-heater-service">Ensure optimal cooling performance with our expert outdoor unit checkup service, designed to inspect and maintain your AC effectively.</p>
      </div>
    </div>

   
    
  </div>
</section>

<section id="working-hours">
  <h2>Our Working Hours</h2>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="working-day">
        <p id="sunday" className="day">Sunday: <span className="status" style={{ color: 'red' }}>Closed</span></p>



        </div>
        <div class="working-day">
          <p id="monday" class="day">Monday: <span class="status">9 AM - 9 PM</span></p>
        </div>
        <div class="working-day">
          <p id="tuesday" class="day">Tuesday: <span class="status">9 AM - 9 PM</span></p>
        </div>
        <div class="working-day">
          <p id="wednesday" class="day">Wednesday: <span class="status">9 AM - 9 PM</span></p>
        </div>
        <div class="working-day">
          <p id="thursday" class="day">Thursday: <span class="status">9 AM - 9 PM</span></p>
        </div>
        <div class="working-day">
          <p id="friday" class="day">Friday: <span class="status">9 AM - 9 PM</span></p>
        </div>
        <div class="working-day">
          <p id="saturday" class="day">Saturday: <span class="status">9 AM - 9 PM</span></p>
        </div>
      </div>
    </div>
  </div>
</section>








<section id="faq-section">
  <h2>Frequently Asked Questions (FAQ)</h2>

  <table class="table table-striped">
  <thead>
  <tr>
    <th>Service</th>
    <th>Question</th>
    <th>Answer</th>
  </tr>
</thead>
<tbody>
  <tr>
    <td>AC Service</td>
    <td>How often should I service my AC?</td>
    <td>It is recommended to service your AC at least once every 6 months to ensure efficient performance and avoid breakdowns.</td>
  </tr>
  <tr>
    <td>AC Installation</td>
    <td>What is included in your AC installation service?</td>
    <td>Our AC installation service includes expert setup, proper alignment, and testing to ensure optimal cooling and energy efficiency.</td>
  </tr>
  <tr>
    <td>AC Gas Checkup</td>
    <td>How do I know if my AC needs a gas refill?</td>
    <td>If your AC is not cooling effectively or takes longer to cool, it may need a gas refill. A professional checkup is recommended.</td>
  </tr>
  <tr>
    <td>AC Indoor Unit Cleaning</td>
    <td>Why is indoor unit cleaning important?</td>
    <td>Indoor unit cleaning removes dust and debris, improving air quality and ensuring efficient cooling performance.</td>
  </tr>
  <tr>
    <td>AC Outdoor Unit Checkup</td>
    <td>What does an outdoor unit checkup include?</td>
    <td>Our outdoor unit checkup includes inspecting the condenser, fan, and connections to ensure smooth operation and optimal cooling.</td>
  </tr>
  <tr>
    <td>AC Dust Cleaning</td>
    <td>How often should I clean the dust from my AC?</td>
    <td>It is advisable to clean the dust from your AC every 3-6 months, depending on usage and environmental factors.</td>
  </tr>
  <tr>
    <td>AC Filter and Grill Cleaning</td>
    <td>What are the benefits of cleaning AC filters and grills?</td>
    <td>Regular cleaning of filters and grills improves air circulation, enhances cooling efficiency, and extends the life of your AC.</td>
  </tr>
</tbody>

  </table>
</section>




<div><Discliamber/></div>

      <div><Footer /></div>
    </>
  );
}
